import React from 'react'
import { Box, Button, Typography, styled } from '@mui/material'
import { commify } from 'ethers/lib/utils'
import Link from 'next/link'
import { FlexCol } from '../common/Columns'
import { RowBetweenCenter, RowCenterY } from '@/components/common/Rows'
import { SUPPORTED_CHAIN } from '@/constants'
import TokenLogo from '@/components/common/TokenLogo'
import BitcoinSvg from '@/assets/imgs/bitcoin.svg'
import { MUBI, TICKERS } from '@/constants/token'
import useCrossChainVolumn from '@/hooks/useCrossChainVolumn'
import { useAllTokenPrice } from '@/hooks/useTokenPrice'

const Title = styled(Typography)`
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0px 0px 40px #bfff0b;
  font-size: 36px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
`

const CardWrapper = styled(FlexCol)`
  border: 1px solid rgba(191, 255, 11, 0.2);
  background: #111303;
  row-gap: 12px;
  padding: 20px;
  flex: 1;
`

const CardTitle = styled(Typography)`
  color: #fff;
  font-feature-settings: 'case' on, 'ss01' on, 'calt' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
`
const CardContentText = styled(Typography)`
  font-feature-settings: 'case' on, 'ss01' on, 'calt' off;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
`

const Dashboard = () => {
  const { allOverCrossChainVolume } = useCrossChainVolumn()

  const { data: prices } = useAllTokenPrice()

  const mubiPrice = prices?.['multibit']

  const totalVolumnText =
    allOverCrossChainVolume && typeof mubiPrice === 'number' ? `$ ${commify(allOverCrossChainVolume.toFixed(2))}` : '-'

  return (
    <div>
      <RowBetweenCenter sx={{ flexWrap: 'wrap', rowGap: 24 }}>
        <Title variant="h1">Dashboard</Title>

        <RowCenterY gap={12}>
          <Typography>Supported Networks</Typography>
          <TokenLogo alt="bitcoin" src={BitcoinSvg} size={24} />
          {Object.values(SUPPORTED_CHAIN).map((chain) => (
            <TokenLogo key={chain.name} alt={chain.name} src={chain.logoSrc} size={24} />
          ))}
        </RowCenterY>
      </RowBetweenCenter>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'auto',
            sm: 'repeat(2, minmax(260px, 1fr) )',
            md: 'repeat(4, minmax(260px, 1fr) )',
          },
          gap: 24,
          mt: 24,
        }}
      >
        <CardWrapper>
          <CardTitle>Number of Assets Supported</CardTitle>
          <CardContentText>{TICKERS.length} Tokens</CardContentText>
        </CardWrapper>

        <CardWrapper>
          <CardTitle>MultiBit Total Volume</CardTitle>
          <CardContentText>{totalVolumnText}</CardContentText>
        </CardWrapper>

        <CardWrapper>
          <RowCenterY gap={12}>
            <TokenLogo alt="MUBI" src={MUBI.logoSrcSet.brc} size={24} />
            <CardTitle>MUBI Price</CardTitle>
          </RowCenterY>
          <CardContentText>$ {mubiPrice || '-'}</CardContentText>
        </CardWrapper>

        <CardWrapper>
          <RowCenterY gap={12}>
            <TokenLogo alt="MUBI" src={MUBI.logoSrcSet.brc} size={24} />
            <CardTitle>MUBI Ecosystem</CardTitle>
          </RowCenterY>

          <RowCenterY gap={12}>
            <Link href="/staking">
              <Button variant="contained" sx={{ height: 34 }}>
                Stake
              </Button>
            </Link>

            <Link href={MUBI.swapInfo[0].url} target="_blank">
              <Button variant="text" sx={{ height: 34, textDecorationLine: 'underline', px: 16 }}>
                Swap
              </Button>
            </Link>
          </RowCenterY>
        </CardWrapper>
      </Box>
    </div>
  )
}

export default Dashboard
